<template>
  <upload-order :fulfillment="true"></upload-order>
</template>

<script>
import UploadOrder from '../UploadOrder.vue'

export default {
  components: {
    UploadOrder
  }
}
</script>